import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { TableKpiProviders } from "./categoryChartData.types";
import { getTariffStructureTableData } from "./fetchTariffStructureTableData";

export const fetchTariffStructureComparisonTableData: CategoryChartQueryFn = async ({
    categoryChart,
    providers
}: CategoryChartQueryParam): Promise<TableKpiProviders> => {
    if (!providers || providers?.length === 0 || !categoryChart) return null;

    const tableData = getTariffStructureTableData(providers);
    return {
        vis: [
            {
                categoryName: categoryChart?.category?.name,
                data: tableData,
                header: {
                    processed: "Providers' Tariff structure",
                    value: "Providers' Tariff structure"
                },
                footer: null,
                type: "tariff-structure"
            }
        ]
    };
};
